import { RuleGuestAttributeResourceTypeRelation, RuleResourceTypeHasNotValue } from "../../../shared/types";
import { RelationRuleValidator } from "./types";

export const relationHasNotValue: RelationRuleValidator<
	RuleResourceTypeHasNotValue<RuleGuestAttributeResourceTypeRelation>
> = {
	validate: (rule, value) => {
		if (value == null) {
			return true;
		}

		switch (rule.guestAttribute.entityType) {
			case "groups":
			case "tags":
			case "tenant":
			case "guestType":
			case "region":
			case "wave": {
				const ruleArray = Array.isArray(rule.value) ? rule.value : [rule.value];
				const valueArray = Array.isArray(value) ? value : [value];
				return ruleArray.length !== valueArray.length || !ruleArray.every((x) => valueArray.includes(x));
			}
			default:
				throw new Error("Not implemented rule");
		}
	},
};
